import { Theme } from '@mui/material';

const generateSx = (prefix: string) => ({
  wrapper: {
    '& .MuiDataGrid-scrollbar': {
      display: 'none',
    },
    border: 'none',
    bgcolor: 'transparent !important',
    '& .MuiDataGrid-detailPanel': {
      backgroundColor: 'transparent',
    },
    [`& .${prefix}-row.MuiDataGrid-row`]: {
      bgcolor: (theme: Theme) =>
        theme.palette.mode === 'dark' ? 'rgb(48 51 57)' : '#f5f5f5',

      borderBottom: (theme: Theme) =>
        `solid 1px ${theme.palette.mode === 'dark' ? 'rgb(80 85 89)' : '#e0e0e0'}`,
    },
    [`& .${prefix}-row.MuiDataGrid-row--detailPanelExpanded`]: {
      mb: '0 !important',
      borderBottom: 0,
    },
    [`& .${prefix}-row .MuiDataGrid-cell`]: {
      border: 'none',
    },
    '& .detail-panel': {
      transition: 'height 0.3s ease',
    },
  },
});

const templatesSx = generateSx('templates');
const stacksSx = generateSx('stacks');

export { templatesSx, stacksSx };
